var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "AppNavigationItem",
    {
      staticClass: "app-navigation-entry-new-calendar",
      class: { "app-navigation-entry-new-calendar--open": _vm.isOpen },
      attrs: {
        title: _vm.$t("calendar", "+ New calendar"),
        "menu-open": _vm.isOpen,
        "menu-icon": "icon-add"
      },
      on: {
        "update:menuOpen": function($event) {
          _vm.isOpen = $event
        },
        "update:menu-open": function($event) {
          _vm.isOpen = $event
        },
        click: function($event) {
          $event.preventDefault()
          $event.stopPropagation()
          return _vm.toggleDialog($event)
        }
      }
    },
    [
      _c(
        "template",
        { slot: "actions" },
        [
          _vm.showCreateCalendarLabel
            ? _c(
                "ActionButton",
                {
                  attrs: { icon: "icon-new-calendar" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      $event.stopPropagation()
                      return _vm.openCreateCalendarInput($event)
                    }
                  }
                },
                [
                  _vm._v(
                    "\n\t\t\t" +
                      _vm._s(_vm.$t("calendar", "New calendar")) +
                      "\n\t\t"
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showCreateCalendarInput
            ? _c("ActionInput", {
                attrs: { icon: "icon-new-calendar" },
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    $event.stopPropagation()
                    return _vm.createNewCalendar($event)
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.showCreateCalendarSaving
            ? _c("ActionText", { attrs: { icon: "icon-loading-small" } }, [
                _vm._v(
                  "\n\t\t\t" +
                    _vm._s(_vm.$t("calendar", "Creating calendar …")) +
                    "\n\t\t"
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.showCreateCalendarTaskListLabel
            ? _c(
                "ActionButton",
                {
                  attrs: { icon: "icon-new-calendar-with-task-list" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      $event.stopPropagation()
                      return _vm.openCreateCalendarTaskListInput($event)
                    }
                  }
                },
                [
                  _vm._v(
                    "\n\t\t\t" +
                      _vm._s(
                        _vm.$t("calendar", "New calendar with task list")
                      ) +
                      "\n\t\t"
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showCreateCalendarTaskListInput
            ? _c("ActionInput", {
                attrs: { icon: "icon-new-calendar-with-task-list" },
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    $event.stopPropagation()
                    return _vm.createNewCalendarTaskList($event)
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.showCreateCalendarTaskListSaving
            ? _c("ActionText", { attrs: { icon: "icon-loading-small" } }, [
                _vm._v(
                  "\n\t\t\t" +
                    _vm._s(_vm.$t("calendar", "Creating calendar …")) +
                    "\n\t\t"
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.showCreateSubscriptionLabel
            ? _c(
                "ActionButton",
                {
                  attrs: { icon: "icon-public" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      $event.stopPropagation()
                      return _vm.openCreateSubscriptionInput($event)
                    }
                  }
                },
                [
                  _vm._v(
                    "\n\t\t\t" +
                      _vm._s(
                        _vm.$t(
                          "calendar",
                          "New subscription from link (read-only)"
                        )
                      ) +
                      "\n\t\t"
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showCreateSubscriptionInput
            ? _c("ActionInput", {
                attrs: { icon: "icon-public" },
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    $event.stopPropagation()
                    return _vm.createNewSubscription($event)
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.showCreateSubscriptionSaving
            ? _c("ActionText", { attrs: { icon: "icon-loading-small" } }, [
                _vm._v(
                  "\n\t\t\t" +
                    _vm._s(_vm.$t("calendar", "Creating subscription …")) +
                    "\n\t\t"
                )
              ])
            : _vm._e()
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }